export default __webpack_public_path__ + "static/media/i_bus-dbl_bl_tagless.a9d7aaae.svg";